import React, { useRef, useEffect } from 'react'

export default function InputComponent({ value = '', onChange }) {
  const divRef = useRef(null)

  useEffect(() => {
    const el = divRef.current
    if (!el) return
    if (el.textContent !== value) el.textContent = value
  }, [value])

  return (
    <span className="fdai-structured-input-wrap">
      <span
        ref={divRef}
        contentEditable
        suppressContentEditableWarning
        className="fdai-structured-input"
        onInput={e => onChange?.(e.currentTarget.textContent || '')}
      />
    </span>
  )
}
